import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useContext, useEffect } from 'react';
import { AuthContext } from '@/context/AuthContext';

export const Route = createFileRoute('/auth/logout')({
  component: LogoutComponent,
});

function LogoutComponent() {
  const auth = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    const handleLogout = async () => {
      if (auth) {
        const { error } = await auth.logout();
        if (error) {
          console.error('Logout failed:', error.message);
        } else {
          navigate({ to: '/auth/login', replace: true, search: { returnTo: undefined } });
        }
      }
    };

    handleLogout();
  }, [auth, navigate]);

  if (auth?.loading) {
    return (
      <div className="flex items-center justify-center min-h-screen pb-safe pt-safe pl-safe pr-safe">
        <p>Logging out...</p>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen pb-safe pt-safe pl-safe pr-safe">
      <p>Redirecting to login...</p>
    </div>
  );
} 